import { Component, DestroyRef, EventEmitter, Input, OnInit, Output, inject } from '@angular/core';
import { takeUntilDestroyed } from '@angular/core/rxjs-interop';
import { TopicListVisibleService } from '../../../home/services/topic-list-visible.service';

@Component({
  selector: 'app-arrow-toggle-button',
  templateUrl: './arrow-toggle-button.component.html',
  styleUrls: ['./arrow-toggle-button.component.scss'],
  standalone: false
})
export class ArrowToggleButtonComponent implements OnInit {
  private topicListVisible = inject(TopicListVisibleService);
  private destroyRef = inject(DestroyRef);

  // eslint-disable-next-line @angular-eslint/no-output-native
  @Output() toggle = new EventEmitter<void>();
  @Input() mode = 'horizontal'; // default
  @Input() isTopicListView = false;
  @Input() isDefaultValue = true;

  ngOnInit(): void {
    if (this.isTopicListView) {
      this.topicListVisible.change$.pipe(takeUntilDestroyed(this.destroyRef)).subscribe(tlv => {
        this.isDefaultValue = !!tlv;
      });
    }
  }

  toggleIt(): void {
    this.toggle.emit();
  }
}
